import ApiService from '../api.service';

const ProofOriginResource = {
  send: (params) => ApiService.post('/v1/proof_origins', params),
  autoProof: (params) => ApiService.post('/v1/proof_origins/auto_proof', params),
};

export default ProofOriginResource;
